import { ATable } from '@congacommerce/core';
import { EglBasePav } from './egl-base-pav';
@ATable({
    sobjectName: 'Apttus_QPConfig__ProposalProductAttributeValue__c',
})
export class EglQuotePAVLight extends EglBasePav {}
